import React,{Fragment} from "react";
import {Col, Row} from "react-bootstrap";
// import Swiper core and required components
import SwiperCore, {Navigation, Scrollbar, A11y, Lazy} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import CardProduct from "../card/CardProduct";
import CardFoodPackage from "../card/CardFoodPackage";

import {Link, useLocation, useRouteMatch} from "react-router-dom";
import {FaAngleDoubleRight} from "react-icons/all";


// install Swiper components
SwiperCore.use([Navigation, Scrollbar, A11y, Lazy]);

const SliderProducts = (props) => {
    const {contents, title, all_product_count, type} = props.data;
    let productType = type;
    if(type === undefined || type === null)
        productType = 'product';
    let location = useLocation();
    const match = useRouteMatch();
    const settingSwiper = {
        slidesPerView: 8,
        spaceBetween: productType === 'product' ? 40 : 10,
        freeMode: true,
        loop: false,
        // nested: true,
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 8,
            loadOnTransitionStart: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: productType === 'product' ? 2.5 : 1.3,
                spaceBetween: 0,
                lazy: {
                    loadPrevNextAmount: productType === 'product' ? 3 : 2,
                },
            },
            576: {
                slidesPerView: productType === 'product' ? 3 : 1.8,
                spaceBetween: productType === 'product' ? 40 : 10,
            },
            700: {
                slidesPerView: productType === 'product' ? 4 : 2.1,
                lazy: {
                    loadPrevNextAmount: 4,
                },
            },
            830: {
                slidesPerView: productType === 'product' ? 5 : 2.2,
                lazy: {
                    loadPrevNextAmount: 5,
                },
            },
            // 1000 ro faghat bekhatere type package ezafe kardim
            1000: {
                slidesPerView: productType === 'product' ? 5 : 2.7,
                lazy: {
                    loadPrevNextAmount: 5,
                },
            }, 
            1100: {
                slidesPerView: productType === 'product' ? 5 : 3.3,
                lazy: {
                    loadPrevNextAmount: 5,
                },
            }, 
            1200: {
                slidesPerView: productType === 'product' ? 6 : 3.5,
                lazy: {
                    loadPrevNextAmount: 6,
                },
            },
            1400: {
                slidesPerView: productType === 'product' ? 6 : 4.3,
            },
            1500: {
                slidesPerView: productType === 'product' ? 7 : 4.4,
                lazy: {
                    loadPrevNextAmount: 7,
                },
            },
            1800: {
                slidesPerView: productType === 'product' ? 8 : 5.3,
                lazy: {
                    loadPrevNextAmount: 8,
                },
            },
            2000: {
                slidesPerView: productType === 'product' ? 10 : 5.8,
                lazy: {
                    loadPrevNextAmount: 10,
                },
            }
        }
    }
    return (
        <div className="base-box-swiper-products">
            <div className='box-header-swiper-products'>
                <div className={'base-btn-more-and-title-swiper-products base-btn-more-part-swiper-products'}>
                    {productType === 'product' ?
                    <>
                    <FaAngleDoubleRight className={'base-arrow-more-part-swiper-products'} />
                    
                    <span>
                        <Link to={`/stores/${match.params.store}/more-products/${title}`}
                              className={'base-link-more-part-swiper-products'}>
                            {all_product_count ?
                                <Fragment>
                                    <span>{all_product_count}</span>
                                    <span className='ml-2'>محصول دیگر</span>
                                </Fragment>
                                : <span>محصولات بیشتر</span>}
                        </Link>
                    </span>
                    </>
                    : ''}
                </div>
                <div className={'base-btn-more-and-title-swiper-products base-title-part-swiper-products'}>
                    <span>{title}</span>
                </div>
            </div>
            <Row>
                <Col>
                    <div className={'swiper-cm-products'} dir={'ltr'}>
                        <Swiper {...settingSwiper}>
                            {contents.map((item, index) => <SwiperSlide key={index}>{productType === 'product' ? <CardProduct
                                product={item}/> : <CardFoodPackage package={item} />}</SwiperSlide>)}
                            {!location.pathname.startsWith(`${match.url}/more-products/`) && productType === 'product' ?
                                <SwiperSlide>
                                    <Link to={`/stores/${match.params.store}/more-products/${title}`}
                                          className={'base-link-more-part-swiper-products'}>

                                        <img
                                            src="https://fruitmruit.com/images/products/155-155/92b7293a0cef67bc210fb6769c83a112.jpg"
                                            alt="محصولات بیشتر"/>
                                        <div className='d-flex justify-content-center flex-row-reverse'>
                                            {all_product_count ?
                                                <Fragment>
                                                    <span>{all_product_count}</span>
                                                    <span className='ml-2'>محصول دیگر</span>
                                                </Fragment>
                                                : <span>محصولات بیشتر</span>}
                                        </div>
                                    </Link>
                                </SwiperSlide> : ''}
                            <div className="swiper-button-prev swiper-button-custom"/>
                            <div className="swiper-button-next swiper-button-custom"/>
                        </Swiper>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default SliderProducts;
